import { gql } from '@apollo/client';
import { RETURN_SUMMARY_FRAGMENT, ReturnSummary } from '../returnSummary.rest';

export type UpdateReturnSummaryMutationVariables = {
  id: string;
  input: {
    data: {
      type: 'return_summary';
      id: string;
      attributes: {
        country_code: string;
        return_method_id: number;
        return_option_id: number;
        return_reason_hash: { [id: string]: number };
        selected_item_ids: string[];
      };
    };
  };
};

export type UpdateReturnSummaryMutation = {
  updateReturnSummary: {
    __typename: 'RestUpdateReturnSummary';
    data: ReturnSummary[];
  };
};

export const UPDATE_RETURN_SUMMARY_MUTATION = gql`
  mutation UpdateReturnSummaryMutation($id: String!, $input: UpdateReturnSummaryMutationInput!) {
    updateReturnSummary(id: $id, input: $input)
      @rest(
        type: "RestUpdateReturnSummary"
        endpoint: "cart"
        path: "/v3.5/return_summary/{args.id}"
        method: "PATCH"
      ) {
      data @type(name: "RestReturnSummary") {
        ...ReturnSummaryFragment
      }
    }
  }
  ${RETURN_SUMMARY_FRAGMENT}
`;
